import { axiosService } from '@/services/AxiosService';
import { useToast } from 'vue-toastification';

/**
 * @typedef {Object} HorseStable
 * @property {number} id
 * @property {string|null} name
 * @property {string} created
 * @property {string} modified
 * @property {number} riding_stable_id
 */

class HorseStablesService {
	getPath = '/horse-stables/get?riding_stable_id=';
	postPath = '/horse-stables/save';
	delPath = '/horse-stables/delete';
	toast = useToast();
	horseStables = [];

	constructor() {
		this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
	}

	/**
	 * Ottieni la lista delle scuderie per il riding stable.
	 * @returns {Promise<HorseStable[]>} I dati delle scuderie.
	 * @throws {Error} Se la richiesta fallisce.
	 */
	async getHorseStables(page, search = '', params = {}, length = 10) {
		try {
			const response = await this.axiosInstance.get(
				this.getPath + params.riding_stable_id,
				{ page, length, search }
			);

			if (response.status !== 200) {
				throw new Error('Failed to fetch horse stables info');
			}

			/** @type {HorseStable[]} */
			// console.log('HorseStablesResponse ---> ', response);
			const horseStablesData = { data: response.data.horse_stables };
			this.horseStables = response.data.horse_stables;
			return horseStablesData;
		} catch (error) {
			console.error('Error fetching horse stables info:', error);
			throw error; // Rialza l'errore per gestirlo nel chiamante
		}
	}

	getHorseStableById(horseStable_id) {
		const result = this.horseStables.find(
			(horseStable) => horseStable.id === horseStable_id
		);
		return result;
	}

	/**
	 * Crea/modifica la scuderia del riding stable.
	 * @returns {Promise<string>} Messaggio di conferma con ID.
	 * @throws {Error} Se la richiesta fallisce.
	 */
	async saveHorseStalble(riding_stable_id, horseStable) {
		try {
			const horseStableData = {
				name: horseStable.name,
				riding_stable_id: riding_stable_id,
			};
			if (horseStable.id) {
				horseStableData.id = horseStable.id;
			}

			const response = await this.axiosInstance.post(
				this.postPath,
				horseStableData
			);

			if (response.status !== 200) {
				throw new Error('Failed to create member');
			}

			/** @type {string} */
			// console.log('messageResponse ---> ', response);
			// const messageResponse = response.data.message;
			// this.toast.success(messageResponse);
			return response;
		} catch (error) {
			this.toast.error(error);
			console.error('Error adding member:', error);
			throw error; // Rialza l'errore per gestirlo nel chiamante
		}
	}

	/**
	 * Elimina scuderia per il riding stable.
	 * @returns {Promise<string>} Messaggio di conferma.
	 * @throws {Error} Se la richiesta fallisce.
	 */
	async deleteHorseStable(riding_stable_id, horseStable_id) {
		try {
			const response = await this.axiosInstance.delete(this.delPath, {
				data: {
					id: horseStable_id,
					riding_stable_id: riding_stable_id,
				},
			});

			if (response.status !== 200) {
				throw new Error('Failed to delete member');
			}

			/** @type {string} */
			// console.log('messageResponse ---> ', response);
			const messageResponse = response.data.message;
			this.toast.success(messageResponse);
			return messageResponse;
		} catch (error) {
			this.toast.error(error);
			console.error('Error deleting member:', error);
			throw error; // Rialza l'errore per gestirlo nel chiamante
		}
	}
}

export const horseStablesService = new HorseStablesService();
